import React, { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './NotificationOverlay.module.scss';

interface NotificationOverlayProps {
  children: ReactNode;
}

const NotificationOverlay = ({ children }: NotificationOverlayProps) => {
  return (
    <div
      className={classNames('fixed-top', styles.overlay)}
      data-testid="notification-overlay"
    >
      {children}
    </div>
  );
};

export default NotificationOverlay;
